/** localStorage key — first visit per browser; dismiss is permanent */
export const APP_DOWNLOAD_PROMPT_STORAGE_KEY = 'naha_app_download_prompt_dismissed'

export function isAppDownloadPromptDismissed () {
  try {
    return localStorage.getItem(APP_DOWNLOAD_PROMPT_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export function dismissAppDownloadPromptForever () {
  try {
    localStorage.setItem(APP_DOWNLOAD_PROMPT_STORAGE_KEY, '1')
  } catch {
    // private browsing / blocked storage
  }
}

/** sessionStorage key — this tab was opened by the native app */
export const OPENED_FROM_APP_STORAGE_KEY = 'naha_opened_from_app'

/**
 * Native apps tag Stripe return URLs with `from=app`. Those pages load in the
 * app's in-app browser (SFSafariViewController / Custom Tab), which isn't
 * signed in, so without this they'd get the "Get the app" prompt. Call once
 * at startup, before routing can redirect and drop the query string.
 */
export function rememberOpenedFromApp (search = typeof window === 'undefined' ? '' : window.location.search) {
  if (new URLSearchParams(search).get('from') !== 'app') return
  try {
    sessionStorage.setItem(OPENED_FROM_APP_STORAGE_KEY, '1')
  } catch {
    // private browsing / blocked storage
  }
}

export function isOpenedFromApp () {
  try {
    return sessionStorage.getItem(OPENED_FROM_APP_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/** Tablets included (max-width 1024px) */
export function isMobileWebViewport () {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(max-width: 1024px)').matches
}

/** @returns {'ios' | 'android' | null} */
export function detectMobileStorePlatform () {
  if (typeof navigator === 'undefined') return null
  const ua = navigator.userAgent || ''
  if (/Android/i.test(ua)) return 'android'
  if (/iPad|iPhone|iPod/i.test(ua)) return 'ios'
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios'
  return null
}
